import { TabModel } from '../../Models/TabModel';
import InputContentChip from './InputContentChip';

type TabsItemsInputContentProps = {
	value: TabModel[] | undefined;
};

export default function TabsItemsInputContent({ value }: TabsItemsInputContentProps) {
	if (!value || value.length === 0) {
		return null;
	}

	const label = value.length === 1 ? '1 tab' : `${value.length} tabs`;

	return <InputContentChip label={label} />;
}
